import type { ResumeVariant, ResumeVariantId } from './types';

export const RESUME_VARIANTS: ResumeVariant[] = [
  {
    id: 'fullstack',
    label: 'Full-Stack',
    title: 'Senior Full-Stack Software Engineer',
    keywords: ['react', 'next', 'node', 'typescript', 'mysql', 'aws', 'fullstack', 'erp', 'saas', 'crm'],
    maxExperiences: 4,
    maxProjects: 5,
  },
  {
    id: 'backend',
    label: 'Backend',
    title: 'Senior Backend Software Engineer',
    keywords: ['node', 'php', 'mysql', 'mongodb', 'api', 'express', 'rest', 'backend', 'sql'],
    maxExperiences: 4,
    maxProjects: 4,
  },
  {
    id: 'frontend',
    label: 'Frontend',
    title: 'Senior Frontend Software Engineer',
    keywords: ['react', 'next', 'typescript', 'javascript', 'tailwind', 'frontend', 'css', 'html'],
    maxExperiences: 3,
    maxProjects: 4,
  },
  {
    id: 'react-next',
    label: 'React / Next.js',
    title: 'Senior React / Next.js Engineer',
    keywords: ['react', 'next', 'typescript', 'javascript', 'tailwind', 'frontend'],
    maxExperiences: 3,
    maxProjects: 4,
  },
  {
    id: 'node',
    label: 'Node.js',
    title: 'Senior Node.js Engineer',
    keywords: ['node', 'express', 'mongodb', 'typescript', 'api', 'rest', 'backend'],
    maxExperiences: 4,
    maxProjects: 4,
  },
  {
    id: 'php',
    label: 'PHP',
    title: 'Senior PHP Software Engineer',
    keywords: ['php', 'mysql', 'wordpress', 'laravel', 'backend', 'saas'],
    maxExperiences: 4,
    maxProjects: 4,
  },
  {
    id: 'ai-automation',
    label: 'AI & Automation',
    title: 'Senior Software Engineer — AI & Automation',
    keywords: ['ai', 'openai', 'automation', 'n8n', 'twilio', 'quickbooks', 'integration', 'workflow'],
    maxExperiences: 4,
    maxProjects: 5,
  },
  {
    id: 'mobile-java',
    label: 'Mobile / Java',
    title: 'Senior Mobile Software Engineer',
    keywords: ['java', 'android', 'bluetooth', 'mobile', 'iot', 'embedded', 'firebase'],
    maxExperiences: 3,
    maxProjects: 3,
  },
  {
    id: 'devops-cloud',
    label: 'DevOps / Cloud',
    title: 'Senior Software Engineer — Cloud & DevOps',
    keywords: ['aws', 's3', 'ci/cd', 'docker', 'nginx', 'linux', 'devops', 'cloud', 'deployment'],
    maxExperiences: 4,
    maxProjects: 3,
  },
  {
    id: 'general',
    label: 'General Software Engineer',
    title: 'Senior Software Engineer',
    keywords: [],
    maxExperiences: 5,
    maxProjects: 6,
  },
];

export function getVariant(id: ResumeVariantId): ResumeVariant {
  return RESUME_VARIANTS.find((v) => v.id === id) ?? RESUME_VARIANTS[0];
}

export function scoreItem(
  text: string,
  tags: string[] | undefined,
  keywords: string[]
): number {
  if (!keywords.length) return 1;
  const haystack = `${text} ${(tags || []).join(' ')}`.toLowerCase();
  return keywords.reduce((score, keyword) => (haystack.includes(keyword) ? score + 1 : score), 0);
}
